import Image from 'next/image'
import styles from './styles/deal-sync-sidebar-modal.module.scss'

interface DealSyncSideBarModalBaseProps {
  children: React.ReactNode
}

export const DealSyncSideBarModalBase = ({
  children,
}: DealSyncSideBarModalBaseProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.image}></div>
      <div
        className="relative"
        style={{
          aspectRatio: '32 / 6',
          margin: '0 auto',
          height: '50px',
        }}
      >
        <Image
          src="/assets/creatorland-deal-sync-logo-2.png"
          alt="Logo Sync"
          style={{
            objectFit: 'contain',
            width: '100%',
          }}
          layout="fill"
        />
      </div>
      <div className="py-26">{children}</div>
    </div>
  )
}
